import axios from "axios";

export const offerData = () => {
    return axios
      .get("/offers")
      .then((response) => {
        // console.log(response.data);
        return response;
      });
  };